<aig-modal class="aig-cookies c-modal" position="center">
    <div class="aig-cookies__body u-pt-6" body>
        <div class="aig-cookies__container u-ds-grid u-gap-16 u-p-4">
            <div *ngIf="mainText">
                <aig-main-text></aig-main-text>
            </div>
            <div *ngIf="optionSelection">
                <aig-option-selection></aig-option-selection>
            </div>
        </div>
    </div>
    <div class="aig-cookies__buttons u-border-top u-pt-4 u-pb-6 u-px-3 u-ds-flex u-gap-24" buttons>
        <button class="aig-cookies__button e-btn--secondary u-justify-center" (click)="aceptAllCookies()">
            Aceptar todas
        </button>
        <button class="aig-cookies__button e-btn--secondary u-justify-center" (click)="aceptFunctionalCookies()">
            Solo funcionales
        </button>
        <button class="aig-cookies__button e-btn--secondary u-justify-center" *ngIf="config" (click)="configCookies()">
            Configuración
        </button>
        <button class="aig-cookies__button e-btn--secondary u-justify-center" *ngIf="savePref" (click)="savePreferencies()">
            Guardar preferencias
        </button>
    </div>
</aig-modal>